import { css } from 'aphrodite';
import { Switch, useLocation } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../components-v2/Drawer/AppDrawer';
import { DonationsImport } from '../../components/dataBoards/donations/DonationsImport';
import { OpportunitiesImport } from '../../components/dataBoards/opportunities/OpportunitiesImport';
import { PrivateRoute } from '../../components/PrivateRoute';
import { OpportunitiesBoard } from '../../containers/dataBoards/OpportunitiesBoard';
import { Opportunity } from '../../containers/dataBoards/Opportunity';
import { PolicyContactsImportFromCSVPage } from '../../containers/PolicyContactsImportFromCSVPage';
import { DefaultUniversalAssistantChat } from '../../containers/templates/AssistantChat';
import { DataBoardsHome } from '../../pages/DataBoards/Home/Home';
import { PoliciesBoard } from '../../pages/DataBoards/PoliciesBoard';
import { DonationsBoard } from './DonationsBoard';
import { styleSheet } from './styles';

export const DataBoardsRoute = () => {
	const userSession = useUserSession();
	const location = useLocation();
	const showDonations = userSession.account.features?.boards?.donationsEnabled;
	const showPolicies = userSession.account.features?.boards?.policiesEnabled;

	return (
		<>
			<Switch location={location}>
				<PrivateRoute path='/dataBoards/opportunities/:id/import' userSession={userSession}>
					<OpportunitiesImport />
				</PrivateRoute>
				<PrivateRoute
					path='/dataBoards/opportunities/:boardId/:id'
					pageViewLogName='opportunity'
					userSession={userSession}
				>
					<Opportunity routeContainerClassName={`main-container-child ${css(styleSheet.opportunitiesContainer)}`} />
				</PrivateRoute>
				<PrivateRoute path='/dataBoards/opportunities/:id' pageViewLogName='opportunities' userSession={userSession}>
					<OpportunitiesBoard routeContainerClassName='main-container-child' />
				</PrivateRoute>
				{showDonations ? (
					<PrivateRoute path='/dataBoards/donations/import' userSession={userSession}>
						<DonationsImport />
					</PrivateRoute>
				) : null}
				{showDonations ? (
					<PrivateRoute path='/dataBoards/donations' pageViewLogName='donations' userSession={userSession}>
						<DonationsBoard />
					</PrivateRoute>
				) : null}
				{showPolicies ? (
					<PrivateRoute path='/dataBoards/policies/contacts-self-import' userSession={userSession}>
						<PolicyContactsImportFromCSVPage />
					</PrivateRoute>
				) : null}
				{showPolicies ? (
					<PrivateRoute path='/dataBoards/policies' pageViewLogName='policies' userSession={userSession}>
						<PoliciesBoard />
					</PrivateRoute>
				) : null}

				<PrivateRoute userSession={userSession}>
					<DataBoardsHome />
				</PrivateRoute>
			</Switch>
			<AppDrawer>
				<StickyAppDrawerContent value='ai-assistant'>
					<DefaultUniversalAssistantChat />
				</StickyAppDrawerContent>
				<AppDrawerToolbar>
					<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
				</AppDrawerToolbar>
			</AppDrawer>
		</>
	);
};
